import Vue from 'vue'
import Vuex from 'vuex'

import firebaseConfig from "@/firebaseConfig";
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';

//import { getAuth, onAuthStateChanged } from "firebase/auth";

import user from './user'
import shared from './shared'

const app = initializeApp(firebaseConfig);


const state = {
  firebase: app,
  db: getFirestore(app)
  // auth: getAuth(),
  // onAuthStateChanged: onAuthStateChanged(getAuth())
}

Vue.use(Vuex)

export const store = new Vuex.Store({
  state,
  modules: {
    user: user,
    shared: shared
  }
})
